import { Utility } from "../../utils";

export interface MinPerson {
    firstName?: string;
    middleName?: string;
    lastName?: string;
    profilePicture?: string;
}

export interface Person extends MinPerson {
    id: number;
    username?: string;
}

export class PersonHelper {
    public static getAvatarUrl(p?: MinPerson) {
        if (!p)
            return "";
        return p.profilePicture || `https://via.placeholder.com/300/bbb/ffffff?text=${PersonHelper.getInitials(p)}`;
    }

    public static getFullName(p?: MinPerson) {
        if (!p)
            return "";
        return Utility.joinSkipEmpty([p.firstName, p.middleName, p.lastName], " ");
    }

    public static getFullNameWithSuffix(p?: MinPerson & { title?: string | null }) {
        if (!p)
            return "";
        return `${Utility.joinSkipEmpty([p.firstName, p.middleName, p.lastName], " ")}${p.title ? (`, ${p.title}`) : ""}`;
    }

    public static getInitials(p?: MinPerson, upperCase: boolean = true) {
        const initials: string[] = [];
        if (!p)
            return "";
        if (p.firstName && p.firstName.length)
            initials.push(p.firstName.substr(0, 1));
        if (p.lastName && p.lastName.length)
            initials.push(p.lastName.substr(0, 1));
        return upperCase
            ? initials.join("").toUpperCase()
            : initials.join("");
    }
}



// WEBPACK FOOTER //
// ./src/models/generic/Person.ts